import { render, staticRenderFns } from "./VuesticIconVue.vue?vue&type=template&id=051e7798"
import script from "./VuesticIconVue.vue?vue&type=script&lang=js"
export * from "./VuesticIconVue.vue?vue&type=script&lang=js"
import style0 from "./VuesticIconVue.vue?vue&type=style&index=0&id=051e7798&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('051e7798')) {
      api.createRecord('051e7798', component.options)
    } else {
      api.reload('051e7798', component.options)
    }
    module.hot.accept("./VuesticIconVue.vue?vue&type=template&id=051e7798", function () {
      api.rerender('051e7798', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-icon/VuesticIconVue.vue"
export default component.exports